import { useQuery } from '@apollo/client/react';

import { getQuery } from '../../services/EstablishmentService';

export const useEstablishment = (establishmentId) => {
  const { data, loading, error } = useQuery(getQuery, {
    fetchPolicy: 'network-only',
    variables: { id: establishmentId }
  });

  return { establishment: data?.establishment || null, loading, error };
};
